import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IBranchMast } from "../../models/BranchMast";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { EmptyBranch } from "./EmptyBranch";
import { ICompanyMastDropdown } from "../../models/IDropdown";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    branchName: yup.string().required("Branch Name is required*"),
    branchCode: yup.string().required("Branch Code is required*").typeError("Branch Code is required*"),
    brachDescription: yup.string().nullable(),
    company_ID: yup.number().min(1, "Company is required*").required("Company is required*")
});

interface Iprops {
    singleData: IBranchMast,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IBranchMast>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadCompanies();
    }, []);

    const saveToDB = async (body: IBranchMast) => {
        const method = props.singleData.branch_ID ? "PUT" : "POST";
        const message = props.singleData.branch_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Branch_Mast", method, body, null, props.toast);

        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyBranch);
    }

    function onSubmit(data: IBranchMast) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Branch" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown required label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" error={errors.company_ID?.message} />
                <JVInput required label="Branch Name" control={control} name="branchName" error={errors.branchName?.message} />
                <JVInput required label="Branch Code" control={control} name="branchCode" error={errors.branchCode?.message} />
                <JVInput label="Branch Description" control={control} name="brachDescription" error={errors.brachDescription?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
